import { buildColourSwatchUrl } from "@/components/Colours/ColoursUI";
import { Product, VariantGroup } from "../../../../../types/types";
import ColourList from "@JohnLewisPartnership/jl-design-system/dist/components/colour/ColourList";
import ColourComponent from "@JohnLewisPartnership/jl-design-system/dist/components/colour/Colour";
import { isDiorBrand } from "@JohnLewisPartnership/jl-design-system/dist/utils/brands/brands";
import { Dispatch, useEffect } from "react";
import styles from "./GiftWithPurchaseColours.module.scss";

type GiftWithPurchaseColoursProps = {
  product: Product;
  colourOptions: GiftWithPurchaseColourOption[];
  selectedVariantGroup?: VariantGroup;
  setSelectedVariantGroup: Dispatch<VariantGroup | undefined>;
  isMobile: boolean;
};

type GiftWithPurchaseColourOption = {
  colour: string;
  showAsAvailable: boolean;
  colourSwatch: string | null | undefined;
  selected: boolean;
};

const sortColourOptions = (colours: GiftWithPurchaseColourOption[]) => {
  const colourOptions = [...colours];

  const colourOptionsAvailable = colourOptions.filter(
    (colourOption) => colourOption.showAsAvailable,
  );

  const colourOptionsNotAvailable = colourOptions.filter(
    (colourOption) => !colourOption.showAsAvailable,
  );

  const combinedColourOptions = [
    ...colourOptionsAvailable,
    ...colourOptionsNotAvailable,
  ];

  return combinedColourOptions;
};

export const GiftWithPurchaseColours: React.FC<GiftWithPurchaseColoursProps> = (
  giftWithPurchaseColoursProps: GiftWithPurchaseColoursProps,
) => {
  const {
    product,
    selectedVariantGroup,
    setSelectedVariantGroup,
    colourOptions,
    isMobile,
  } = giftWithPurchaseColoursProps;

  const sortedColourOptions = sortColourOptions(colourOptions);

  useEffect(() => {
    const defaultVariantGroup = product.variantGroups?.filter(
      (variantGroup) => variantGroup.value === sortedColourOptions[0]?.colour,
    )[0];
    setSelectedVariantGroup(defaultVariantGroup);
  }, []);

  const chooseSelectedColour = (colour: string) => {
    const chosenVariantGroup = product.variantGroups?.filter(
      (variantGroup) => variantGroup.value === colour,
    )[0];
    setSelectedVariantGroup(chosenVariantGroup);
  };

  return (
    <div className={styles.coloursContainer}>
      <ColourList
        showMore={isMobile ? 2 : 3}
        selectedLabel={selectedVariantGroup?.value}
        containerProps={{ ["data-component"]: "Colours" }}
        brand={product.brand?.name}
        hasDiorPromosEnabled={true}
        onClick={(colour: string) => chooseSelectedColour(colour)}
      >
        {sortedColourOptions.map((colourOption, index) => {
          return (
            <ColourComponent
              key={`colourOption-${index}`}
              selected={colourOption.selected}
              unavailable={!colourOption.showAsAvailable}
              name="colourSelector"
              value={colourOption.colour}
              swatch={buildColourSwatchUrl(colourOption.colourSwatch)}
              isDior={isDiorBrand(product.brand?.name)}
            />
          );
        })}
      </ColourList>
    </div>
  );
};
